import { cn } from "@/utils/cn";

interface PurpleRadialGradientProps {
  classNames?: {
    container?: string;
    image?: string;
  };
  children?: React.ReactNode;
}

const PurpleRadialGradientBackground = ({ classNames, children }: PurpleRadialGradientProps) => {
  return (
    <div className={cn("relative h-full w-full overflow-hidden", classNames?.container)}>
      <img
        src="/assets/images/bg-onboarding-screen@1x.png"
        srcSet="/assets/images/bg-onboarding-screen@1x.png 1x, /assets/images/bg-onboarding-screen@2x.png 2x, /assets/images/bg-onboarding-screen@3x.png 3x"
        className={cn(
          "bottom-0, absolute right-0 left-0 -z-10 w-full object-cover",
          classNames?.image,
        )}
        aria-hidden="true"
      />
      {children}
    </div>
  );
};

export default PurpleRadialGradientBackground;
